module.exports = __webpack_public_path__ + "img/cardGallery5.jpg?78e5207c6962898b8f2edb0ec7abe8b2";